import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import {Fade} from "../../components/FadeReveal/FadeReveal";
import "./HowIWork.scss";
import StyleContext from "../../contexts/StyleContext";
import {howIWork} from "../../portfolio";

export default function HowIWork() {
  const {isDark} = useContext(StyleContext);
  const {t} = useTranslation();

  if (!howIWork.display) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className={isDark ? "dark-mode main" : "main"} id="how-i-work">
        <div className="hiw-header">
          <h1 className={isDark ? "dark-mode hiw-title" : "hiw-title"}>
            {t("howIWork.title")}
          </h1>
          <p className={isDark ? "dark-mode hiw-subtitle" : "hiw-subtitle"}>
            {t("howIWork.subtitle")}
          </p>
        </div>
        <div className="hiw-steps">
          {howIWork.phases.map((phase, i) => (
            <div className="hiw-step" key={i}>
              <div className="hiw-icon-wrap">
                <span className="hiw-icon">{phase.icon}</span>
              </div>
              <div className="hiw-step-body">
                <span className="hiw-phase-label">
                  {t("howIWork.phaseLabel", {number: String(i + 1).padStart(2, "0")})}
                </span>
                <h3 className={isDark ? "dark-mode hiw-phase-title" : "hiw-phase-title"}>
                  {t(phase.titleKey)}
                </h3>
                <p className={isDark ? "dark-mode hiw-phase-desc" : "hiw-phase-desc"}>
                  {t(phase.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fade>
  );
}
